import { createTestIdHelper } from '../../../lib/utils';

/**
 * Kept out of the component file so that module only exports components: a non-component
 * export there breaks Fast Refresh (`react-refresh/only-export-components`).
 */
export const notFoundPlaceholderTestId = createTestIdHelper(
  'not-found-placeholder',
);

export const notFoundPlaceholderTestIds = {
  root: notFoundPlaceholderTestId('root'),
  icon: notFoundPlaceholderTestId('icon'),
  title: notFoundPlaceholderTestId('title'),
  description: notFoundPlaceholderTestId('description'),
  action: notFoundPlaceholderTestId('action'),
} as const;
